<template>
  <div>Bitte warten, du wirst sofort zu Giropay weitergeleitet</div>
</template>

<script>
  import endpoints from '../../endpoints'

  export default {
    name: 'Giropay',

    created () {
      window.location.href = endpoints.giropayPay
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/giropay/redirect.vue